import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tool-scout",
  "use": "tool-scout-usage",
  "viewBox": "0 0 22 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 21\" id=\"tool-scout\"><g transform=\"rotate(-45 10.95 8.192)\"><rect height=\"6.964\" rx=\"1.157\" width=\"2.313\" x=\"8\" y=\"17\" /><path d=\"M9 19C3.477 19-1 14.523-1 9S3.477-1 9-1 19 3.477 19 9 14.523 19 9 19zm0-2A8 8 0 1 0 9 1a8 8 0 0 0 0 16z\" /></g><path d=\"M14 5v2.667l-8 2.666V7.667zm0-1.333L6 6.333V1.661h8zM14 9v2.667l-4 4-4-4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol